import axios, { type AxiosError } from "axios";
import { ERRORS } from "constants/error-constants";
import type { Book } from "models/book/Book";
import type { ApiRequestError } from "models/error/Error";
import type { User } from "models/user/User";
import cookieStorage from "persistence";
import { generatePathRoute } from "utils/pathBuilder";
import { CustomError, handlingResponse, logError } from "../utils";

const getUserInfo = async (): Promise<User> => {
  try {
    const url = generatePathRoute("/api/additionals/account");
    const result = await axios.get(url, { headers: { Authorization: cookieStorage.getToken() } });
    return handlingResponse<User>([200], "Error getting account info")(result);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new CustomError({ message, status, type: ERRORS.GET_ACCOUNT_INFO_FAILED });
  }
};

const getLicenses = async (): Promise<Book[]> => {
  try {
    const licenses = await axios.get(generatePathRoute("/api/idp/licenses"), {
      headers: { Authorization: cookieStorage.getToken() },
    });
    return handlingResponse<Book[]>([200], "Error getting licences")(licenses);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new CustomError({ message, status, type: ERRORS.GET_LICENSES_FAILED });
  }
};

export { getUserInfo, getLicenses };
